import type { RacemapStarter } from './events';

export enum PlacingToShadowtrack {
  NoShadowTrack = 'NoShadowTrack',
  FarAway = 'FarAway',
  Near = 'Near',
  Mapped = 'Mapped',
  OnTrack = 'OnTrack',
}

type ReadMeta = {
  hits?: number;
  rssi?: number;
  source?: string;
  quality?: string;
  locationIsUserDefined?: boolean;
  [key: string]: any;
};

type BaseRead = {
  readerId: string;
  readerName: string;
  userId: string;
  chipId: string;
  lat: number | null;
  lng: number | null;
  isTest: boolean;
  isSimulated: boolean;
  meta?: ReadMeta;
};

export type APIRead = BaseRead & {
  readAt: string;
  receivedAt: string;
};

export type Read = BaseRead & {
  readAt: Date;
  receivedAt: Date;
  transponderId?: string;
};

export interface ReadToPush extends BaseRead {
  readAt: Date;
  receivedAt?: Date;
}

export type ReadWithStarter = Read & { id: string; starter?: RacemapStarter };
